var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcFavoriteFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "22px",
    viewBox: "0 0 20 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_ulubione",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.79,16.9 C9.49519387,16.9099767 9.20934611,16.7978085 9,16.59 L2.51,10.3 C2.51,10.3 0,8.08 0,5.31 C0,2 2.08,0 5.42,0 C7.08031715,0.157079694 8.63000218,0.901779594 9.79,2.1 C10.9499978,0.901779594 12.4996828,0.157079694 14.16,0 C17.5,0 19.57,2 19.57,5.31 C19.57,7.72 17.66,9.74 17.07,10.31 L10.54,16.6 C10.3393951,16.7950705 10.069797,16.9029098 9.79,16.9 Z",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFavoriteFull);
export default __webpack_public_path__ + "static/media/ic_favorite_full.893c694856911ede988fc83a6a51c1f8.svg";
export { ForwardRef as ReactComponent };